import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { IDistritoRaw, IMunicipio, LocalidadesIbgeState } from './types';

export const useLocalidadesIbgeStore = create<LocalidadesIbgeState>()(
  devtools(
    (set) => ({
      municipios: [],
      loading: false,
      error: null,
      fetchDistritosByUF: async (uf: string) => {
        if (!uf) {
          set({ municipios: [], error: null });
          return [];
        }
        set({ loading: true, error: null, municipios: [] });
        try {
          const res = await fetch(
            `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/distritos?orderBy=nome`
          );
          if (!res.ok) throw new Error('Falha na resposta do IBGE');
          const data: IDistritoRaw[] = await res.json();

          // Deduplicate municipalities by id
          const seen = new Set<number>();
          const municipios: IMunicipio[] = [];
          for (const d of data) {
            if (!seen.has(d.municipio.id)) {
              seen.add(d.municipio.id);
              municipios.push({ id: d.municipio.id, nome: d.municipio.nome });
            }
          }
          municipios.sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));

          set({ municipios, loading: false });
          return municipios;
        } catch {
          set({
            loading: false,
            error: 'Falha ao buscar municípios do IBGE.',
            municipios: []
          });
          return [];
        }
      }
    }),
    { name: 'LocalidadesIbgeStore' }
  )
);
